<template>
  <div>
    <el-select
      v-model="state4"
      @change="handleInput"
      filterable
      remote
      placeholder="Please enter key words"
      :remote-method="remoteMethod"
      :loading="loading">
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'searchBar',
  data () {
    return {
      state4: '',
      loading: false,
      options: []
    }
  },
  methods: {
    ...mapActions([
      'getGeneSymbolFuzzy',
      'delVisitedViews'
    ]),
    handleInput (item) {
      this.$router.push({
        path: '/bigData/search',
        query: {
          type: item,
          temp: Math.random()
        }
      })
    },
    remoteMethod (query) {
      this.loading = true
      if (query !== '') {
        this.getGeneSymbolFuzzy({
          keyWord: query
        }).then((res) => {
          this.options = res.map((item) => {
            return {
              value: item,
              label: item
            }
          })
          this.loading = false
        })
      } else {
        this.options = []
        this.loading = false
      }
    }
  },
  watch: {
    '$route' (to, from) {
      console.log(this.$route)
      if (this.$route.query.type && this.$route.query.temp) {
        this.state4 = this.$route.query.type
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/searchBar.vue